export default __webpack_public_path__ + "static/media/paper-texture-800-day.8ec81bbf.jpg";